






















































































































import { Component, Mixins } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import Title from "@/components/common/Title.vue";
import QRCode from "qrcode";

interface ReferralOffice {
  issuer_type: number;
  staff_id: number;
  portal_office_id: number;
  office_name: string;
  corp_name: string;
}

interface ReferralCode {
  code: string;
  expires_at: string;
}

interface Registration {
  id: number;
  referred_name: string;
  phone_number: string;
  status: number;
  created_at: string;
}

@Component({ components: { Title } })
export default class JobsearchReferralPage extends Mixins(AxiosMixin) {
  /** 事業所一覧 */
  private offices: ReferralOffice[] = [];

  /** 事業所キーごとの紹介コード */
  private referralCodes: Record<string | number, ReferralCode> = {};

  /** 事業所キーごとの登録者一覧 */
  private registrations: Record<string | number, Registration[]> = {};

  /** コード生成中の事業所キー */
  private generatingOfficeId: string | number = 0;

  mounted(): void {
    this.fetchOfficeList();
  }

  /** 紹介コード発行可能事業所一覧を取得 */
  private fetchOfficeList() {
    this.postJsonCheck(
      window.base_url + "/api/auth/jobsearch-referral/offices",
      {},
      res => {
        this.offices = res.data.offices || [];
      }
    );
  }

  /** 事業所の一意キーを返す（issuer_type=3 は "recruitee"、それ以外は portal_office_id） */
  private officeKey(office: ReferralOffice): string | number {
    if (office.issuer_type === 3) return "recruitee";
    return office.portal_office_id;
  }

  /** 紹介コードを発行 */
  private generateCode(office: ReferralOffice) {
    const key = this.officeKey(office);
    this.generatingOfficeId = key;
    // issuer_type=1: staff_id あり, issuer_type=2: portal_office_id のみ, issuer_type=3: 両方0
    const payload = {
      staff_id: office.issuer_type === 1 ? office.staff_id : 0,
      portal_office_id: office.issuer_type !== 3 ? office.portal_office_id : 0
    };
    this.postJsonCheck(
      window.base_url + "/api/auth/jobsearch-referral/generate-code",
      payload,
      res => {
        this.generatingOfficeId = 0;
        const code = res.data.referral_code;
        this.$set(this.referralCodes, key, {
          code: code.code,
          expires_at: code.expires_at
        });
        this.$nextTick(() => {
          this.renderQrCode(key);
        });
      },
      () => {
        this.generatingOfficeId = 0;
      }
    );
  }

  /** 招待URLを取得 */
  private getReferralUrl(key: string | number): string {
    const code = this.referralCodes[key];
    if (!code) return "";
    return window.kaedoki_frontend_url + "/referral/" + code.code;
  }

  /** QRコードをcanvasに描画 */
  private renderQrCode(key: string | number) {
    const refs = this.$refs["qr-" + key];
    if (!refs) return;
    const canvas = Array.isArray(refs) ? refs[0] : refs;
    if (!canvas) return;
    const url = this.getReferralUrl(key);
    QRCode.toCanvas(canvas as HTMLCanvasElement, url, { width: 160 });
  }

  /** QRコードをPNGダウンロード */
  private downloadQr(key: string | number, officeName: string) {
    const url = this.getReferralUrl(key);
    QRCode.toDataURL(
      url,
      { width: 320 },
      (err: Error | null | undefined, dataUrl: string) => {
        if (err) return;
        const link = document.createElement("a");
        link.download = "kaedoki_referral_" + officeName + ".png";
        link.href = dataUrl;
        link.click();
      }
    );
  }

  /** URLをクリップボードにコピー */
  private async copyUrl(key: string | number) {
    const url = this.getReferralUrl(key);
    try {
      await navigator.clipboard.writeText(url);
      await this.$openAlert("招待URLをコピーしました");
    } catch {
      await this.$openAlert("コピーに失敗しました。手動でコピーしてください。");
    }
  }

  /** パネル開閉時に登録者を取得 */
  private onPanelChange(key: string | number) {
    if (!this.registrations[key]) {
      this.fetchRegistrations(key);
    }
  }

  /** 紹介経由登録者一覧を取得 */
  private fetchRegistrations(key: string | number) {
    // issuer_type=3（カエドキ応募者）は portal_office_id=0 を送る。
    // バックエンドは portal_office_id=0 のとき ewell_user_id で登録者を絞り込む。
    const portalOfficeId = typeof key === "number" ? key : 0;
    this.postJsonCheck(
      window.base_url + "/api/auth/jobsearch-referral/registrations",
      {
        portal_office_id: portalOfficeId,
        page: 1,
        per_page: 20
      },
      res => {
        this.$set(this.registrations, key, res.data.registrations || []);
      }
    );
  }

  /** 事業所キーに対応する登録者一覧を取得 */
  private getRegistrations(key: string | number): Registration[] {
    return this.registrations[key] || [];
  }

  /** ステータスラベル */
  private getStatusLabel(status: number): string {
    switch (status) {
      case 1:
        return "承認待ち";
      case 2:
        return "報酬送付対応中";
      case 3:
        return "完了";
      default:
        return "不明";
    }
  }
}
